<template>
  <v-dialog
		v-model="dialog"
		persistent
		width="750"
	>
		<v-card>
			<!-- Cabecera del formulario -->
			<v-toolbar color="#7e5ec2">
        <span class="material-symbols-outlined">  </span>
            <p class="tituloCard">Ver seguimiento</p>
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
			<!-- Cuerpo del formulario -->
			<v-form
				@submit.prevent="save"
				v-model="valid"
				ref="form"
				lazy-validation
				>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12>
								<h4 ><strong >Número:</strong>   {{this.form.secuencia}}</h4>
							</v-flex>
							<v-flex xs12>
								<h4 ><strong>Nombre:</strong> {{this.form.nombres}}</h4>
							</v-flex>
							<v-flex xs12>
								<h4 ><strong>Cédula:</strong>   {{this.form.nro_doc}}</h4>
							</v-flex>
							
							<v-flex xs12>
								<h4 ><strong>Detalle papeleta</strong> </h4>
							</v-flex>
					    </v-layout>
						<v-layout>
							<v-flex xs12>
								<v-data-table
										:items="lista_papeleta"
										class="elevation-1"
										hide-actions
										:headers="headers"
										>
										<template v-slot:items="props">
											<td class="text-xs-center">{{ props.item.fecha_desde}}</td>
											<td class="text-xs-center">{{ props.item.fecha_hasta}}</td>

											<td class="text-xs-center">{{ props.item.total_dias }}</td>
											<td class="text-xs-center">{{ props.item.estado }}</td>
										</template>
									</v-data-table>
							</v-flex>
						</v-layout>
						<v-flex xs12>
								<h4 ><strong>Seguimiento papeleta</strong> </h4>
							</v-flex>
						<v-layout>
							<v-flex xs12>
								<v-data-table
										:items="lista_detalle"
										class="elevation-1"
										hide-actions
										:headers="headers2"
										>
										<template v-slot:items="props">
											<td class="text-xs-center">{{ props.item.fecha_registro}}</td>
											<td class="text-xs-center">{{ props.item.estado}}</td>
											<td class="text-xs-center">{{ props.item.usuario }}</td>
											<td class="text-xs-center">{{ props.item.jefe }}</td>
										</template>
									</v-data-table>
							</v-flex>
						</v-layout>
					</v-container>
		
				</v-card-text>
				<v-card-actions>
					
					<v-spacer></v-spacer>
					<v-btn
					color="rgba(4, 8, 194, 0.35)"
						@click.native="close()">
						<v-icon>cancel</v-icon> ACEPTAR
					</v-btn>
					
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
import validate from '@/common/mixins/validate'; // Importación de mixin de validaciones

export default {
	// Definición de mixins importados
	mixins: [validate],
	// Variables iniciales
	data () {
		return {
			dialog: false,
			user :this.$storage.get("user"),					
			form: {
				funcionario:{
					nombre:"",
				}
			},
			//url: 'vCronoVacass',
			valid: false,
			loading: false,
			estado_vacacion: [],
			nombre:null,
			fecha_ingreso:null,
			fecha_desde:"",
			fecha_hasta:"",
			persona: null,
			saldo:null,
			periodo: null,
			id: null,
			lista_papeleta:[],
			lista_detalle:[],
			headers: [
				{text: 'Fecha salida',sortable: false,align: 'center'},
				{text: 'Fecha fin',sortable: false,align: 'center'},
				{text: 'Total días',sortable: false,align: 'center'},
				{text: 'Estado',sortable: false,align: 'center'},
			],
			headers2: [
				{text: 'Fecha registro',sortable: false,align: 'center'},
				{text: 'Estado',sortable: false,align: 'center'},
				{text: 'Usuario',sortable: false,align: 'center'},
				{text: 'Solicitud enviada a',sortable: false,align: 'center'},
			],
			
		}
	},
	async mounted () {		
		this.$bus.$on("openDialogVerDetalleUsoFuncionarioNormal", async(item) => {
      	this.form = item;
		this.form.id=parseInt(this.form.id)
	  	this.cargarTablaPapeleta()
      	this.dialog = true;
		await this.cargarSeguimiento()
    });
	},

	methods: {
		close () {
			this.form= {
				funcionario:{
					nombre:"",
				}
			}
			this.lista_papeleta=[]
			this.loading = false
			this.valid = false
			this.$bus.$emit('closeDialogVerDetalleUsoFuncionarioNormal')
			this.dialog = false
		},
	cargarTablaPapeleta(){
		this.lista_papeleta.push(this.form)
	},
	async cargarSeguimiento(){
		try {
		
		let respuesta = await this.$service.graphql({
		query: `
			query{
				runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${this.form.id_vacacion_programada}"){
					respuesta
				}
				}
			`,
		});
		respuesta = respuesta.runQuery.respuesta	
		this.lista_detalle=respuesta
		} catch (error) {
			console.log(error)
		}
	},
		
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_uso/dialogs/VerDetalle.vue